const THERMOSTAT = 0;

const MODE = 23;
const COOLING = 0;
const HEATING = 1;

const PERIOD = 50000;

import gpio 	from "gpio";
import INA219	from "./ina219.js";
import Device   from "../device.js";


class Thermostat extends Device {
  constructor() {
    super();
    
    this.id = "Thermostat";
    this.status = "uninitalized";
    this.voltage = 12;
  }
  initialize() {
    return( new Promise(function(resolve, reject) {
      this.status = "Failed";
      
      this.ina219 = new INA219();
      this.ina219.setCalibration_32V_2A();
      
      if (gpio.pwm[THERMOSTAT].exported()) gpio.pwm[THERMOSTAT].unexport();
      gpio.pwm[THERMOSTAT].export();

      if (gpio.pin[MODE].exported()) gpio.pin[MODE].unexport();
      gpio.pin[MODE].export();


      setTimeout(function() {
        //gpio.pwm[THERMOSTAT].disable();
        //gpio.pwm[THERMOSTAT].enable();

        if (gpio.pwm[THERMOSTAT].duty_cycle != 0)
          gpio.pwm[THERMOSTAT].duty_cycle = 0;
        gpio.pwm[THERMOSTAT].period = PERIOD;

        gpio.pwm[THERMOSTAT].disable();
        gpio.pwm[THERMOSTAT].enable();

        gpio.pin[MODE].direction = 0;
        gpio.pin[MODE].value = COOLING;

        this.usbProductName = "thermostat";
        this.usbSerialNumber = "1";                 
        this.name = "thermostat";

        this.status = "Ok";

        resolve(true);
      }.bind(this), 1000);
    }.bind(this)) );
  }
  update() {
    return( new Promise(function(resolve, reject) {
      this.ina219.getCurrent().then(function(result) {
        /* ina219 smd resistor has been replaced with a 0.01ohm resistor. original:0.1ohm */
        /* the result have to be multiplied by 10 */
        /* so the measurement range is now 0..32A */
        result = result * 10;

        this.current = Math.round(result*100)/100;
        this.power = this.current * this.voltage;
        this.power = Math.round(this.power*100)/100;        

        resolve(true);
      }.bind(this));
    }.bind(this)) );
  }
  set percentage(percentage) {
    if (percentage < 0) throw "Percentage must be between 0..100%";
    if (percentage > 100) throw "Percentage must be between 0..100%";
    if (isNaN(percentage)) throw "Percentage must be a number between 0..100%";
    if (this.mode==HEATING && percentage>40) percentage=40;

    //gpio.pwm[THERMOSTAT].duty_cycle = Math.round(percentage * 1000);
    gpio.pwm[THERMOSTAT].duty_cycle = Math.round(percentage * (PERIOD/100));
    return(true);
  }
  
  set mode(value) {
    if (value==HEATING && this.percentage>40) this.percentage=40;
    gpio.pin[MODE].value = value;
    return(true);
  }
  get mode() {
    return(gpio.pin[MODE].value);
  }
  get percentage() {
    //return(Math.round(gpio.pwm[THERMOSTAT].duty_cycle / 1000));
    return( Math.round((gpio.pwm[THERMOSTAT].duty_cycle*100)/PERIOD) );
  }
  async RM_getCurrent() {
    return this.current;
  }
  async RM_setPercentage(value) {
    this.percentage = value;
  }
  async RM_setMode(value) {
    this.mode = value;
  }  
  logData(logData) {
    logData.append(`${this.name}_pwm`, this.mode==0 ? -this.percentage : this.percentage);    
    logData.append(`${this.name}_w`, this.mode==0 ? -this.power : this.power);    
  }
  
  /*get current() {
		return this.ina219.shuntVoltage;
	}*/
  toJSON() {
    try {
      return({
        name: this.name,            
        usbProductName: this.usbProductName,
        usbSerialNumber: this.usbSerialNumber,      
        status: this.status,      
        id: this.id,      
        percentage: this.percentage,
        mode: this.mode ? 1 : 0,
        voltage: this.voltage,
        current: this.current,
        power: this.power
      });
    } catch(e) {
      return({
        id: this.id,
        status: "Failed",
        percentage: "-",
        mode: "-",
        voltage: "-",
        current: "-",
        power: "-"
      });
    }
  }
}

export default Thermostat;